import { Button } from '@/components/ui';
import type { DropTimelinePickTarget } from '@/features/siem/utils/drop-timeline';

function pickKey(t: DropTimelinePickTarget, i: number): string {
  return `${t.preparedDropId ?? ''}|${t.wiserDropId ?? ''}|${t.uniqueId ?? ''}|${i}`;
}

export function DropTimelinePickStep(props: {
  options: DropTimelinePickTarget[];
  onSelect: (t: DropTimelinePickTarget) => void;
}) {
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">
        Several drops are in this request. Choose one to load its story and activity.
      </p>
      <ul className="space-y-2">
        {props.options.map((t, i) => (
          <li key={pickKey(t, i)}>
            <Button
              type="button"
              variant="outline"
              className="w-full justify-start text-left font-normal"
              onClick={() => props.onSelect(t)}
            >
              {t.label}
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
